export interface PatientAccountTranslations {
  loadingTitle: string;
  loadingText: string;
  accountInfo: {
    title: string;
    accountId: {
      title: string;
      changePassword: string;
    };
    accountHolder: {
      title: string;
      firstName: string;
      lastName: string;
      relationshipToPatient: string;
      address: string;
      city: string;
      state: string;
      zipCode: string;
      phone: string;
      emailForNotifications: string;
      notifications: string;
      notificationsEmail: string;
      loading: string;
      selectAState: string;
      selectARelationship: string;
      selectALanguage: string;
      deleteAccount: string;
      cancel: string;
      saveChanges: string;
      preferredLanguage: string;
    };
  };
  patientInfo: {
    title: string;
    erContact: {
      title: string;
      firstName: string;
      lastName: string;
      relationshipToPatient: string;
      phoneNumber: string;
      emailAddress: string;
      selectARelationship: string;
    };
    preferredFacility: {
      title: string;
      facility: string;
      phoneNumber: string;
      websiteAddress: string;
      cancel: string;
      saveChanges: string;
      selectAFacility: string;
    };
    previousTreatments: {
      title: string;
      addTreatment: string;
      popup: {
        title: string;
        registrationPin: string;
        cancel: string;
        submit: string;
      };
    };
  };
  errors: {
    invalidPhoneNumber: string;
    registrationPinNoMatch: string;
    linkingStay: string;
    pinInvalid: string;
  };
  deletePopup: {
    title: string;
    description: string;
    cancel: string;
    continue: string;
    error: string;
  };
}

export const patientAccountTranslationKeys: PatientAccountTranslations = {
  loadingTitle: 'loadingTitle',
  loadingText: 'loadingText',
  accountInfo: {
    title: 'accountInfo.title',
    accountId: {
      title: 'accountInfo.accountId.title',
      changePassword: 'accountInfo.accountId.changePassword',
    },
    accountHolder: {
      title: 'accountInfo.accountHolder.title',
      firstName: 'accountInfo.accountHolder.firstName',
      lastName: 'accountInfo.accountHolder.lastName',
      relationshipToPatient: 'accountInfo.accountHolder.relationshipToPatient',
      address: 'accountInfo.accountHolder.address',
      city: 'accountInfo.accountHolder.city',
      state: 'accountInfo.accountHolder.state',
      zipCode: 'accountInfo.accountHolder.zipCode',
      phone: 'accountInfo.accountHolder.phone',
      emailForNotifications: 'accountInfo.accountHolder.emailForNotifications',
      notifications: 'accountInfo.accountHolder.notifications',
      notificationsEmail: 'accountInfo.accountHolder.notificationsEmail',
      loading: 'accountInfo.accountHolder.loading',
      selectAState: 'accountInfo.accountHolder.selectAState',
      selectARelationship: 'accountInfo.accountHolder.selectARelationship',
      selectALanguage: 'accountInfo.accountHolder.selectALanguage',
      deleteAccount: 'accountInfo.accountHolder.deleteAccount',
      cancel: 'accountInfo.accountHolder.cancel',
      saveChanges: 'accountInfo.accountHolder.saveChanges',
      preferredLanguage: 'accountInfo.accountHolder.preferredLanguage',
    },
  },
  patientInfo: {
    title: 'patientInfo.title',
    erContact: {
      title: 'patientInfo.erContact.title',
      firstName: 'patientInfo.erContact.firstName',
      lastName: 'patientInfo.erContact.lastName',
      relationshipToPatient: 'patientInfo.erContact.relationshipToPatient',
      phoneNumber: 'patientInfo.erContact.phoneNumber',
      emailAddress: 'patientInfo.erContact.emailAddress',
      selectARelationship: 'patientInfo.erContact.selectARelationship',
    },
    preferredFacility: {
      title: 'patientInfo.preferredFacility.title',
      facility: 'patientInfo.preferredFacility.facility',
      phoneNumber: 'patientInfo.preferredFacility.phoneNumber',
      websiteAddress: 'patientInfo.preferredFacility.websiteAddress',
      cancel: 'patientInfo.preferredFacility.cancel',
      saveChanges: 'patientInfo.preferredFacility.saveChanges',
      selectAFacility: 'patientInfo.preferredFacility.selectAFacility',
    },
    previousTreatments: {
      title: 'patientInfo.previousTreatments.title',
      addTreatment: 'patientInfo.previousTreatments.addTreatment',
      popup: {
        title: 'patientInfo.previousTreatments.popup.title',
        registrationPin: 'patientInfo.previousTreatments.popup.registrationPin',
        cancel: 'patientInfo.previousTreatments.popup.cancel',
        submit: 'patientInfo.previousTreatments.popup.submit',
      },
    },
  },
  errors: {
    invalidPhoneNumber: 'errors.invalidPhoneNumber',
    registrationPinNoMatch: 'errors.registrationPinNoMatch',
    linkingStay: 'errors.linkingStay',
    pinInvalid: 'errors.pinInvalid',
  },
  deletePopup: {
    title: 'deletePopup.title',
    description: 'deletePopup.description',
    cancel: 'deletePopup.cancel',
    continue: 'deletePopup.continue',
    error: 'deletePopup.error',
  },
};

export const patientAccountTranslationsEN: PatientAccountTranslations = {
  loadingTitle: 'Account Information and Settings',
  loadingText: 'Loading Account Settings...',
  accountInfo: {
    title: 'Account Information',
    accountId: {
      title: 'Email Address/Account ID',
      changePassword: 'Change Password',
    },
    accountHolder: {
      title: 'Account Holder Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      relationshipToPatient: 'Relationship to Patient',
      address: 'Address',
      city: 'City',
      state: 'State',
      zipCode: 'ZIP Code',
      phone: 'Phone',
      emailForNotifications: 'Email for Notifications',
      notifications: 'Notifications',
      notificationsEmail: 'Email',
      loading: 'Loading...',
      selectAState: 'Select a State',
      selectARelationship: 'Select a Relationship',
      selectALanguage: 'Select a Language',
      deleteAccount: 'Delete Account',
      cancel: 'Cancel',
      saveChanges: 'Save Changes',
      preferredLanguage: 'Preferred Language',
    },
  },
  patientInfo: {
    title: 'Patient Information',
    erContact: {
      title: 'Emergency Contact',
      firstName: 'First Name',
      lastName: 'Last Name',
      relationshipToPatient: 'Relationship to Patient',
      phoneNumber: 'Phone Number',
      emailAddress: 'Email Address',
      selectARelationship: 'Select a Relationship',
    },
    preferredFacility: {
      title: 'Preferred Facility',
      facility: 'Facility',
      phoneNumber: 'Phone Number',
      websiteAddress: 'Website Address',
      cancel: 'Cancel',
      saveChanges: 'Save Changes',
      selectAFacility: 'Select a Facility',
    },
    previousTreatments: {
      title: 'Previous Inpatient/Outpatient Treatments',
      addTreatment: 'Add an Inpatient/Outpatient Treatment',
      popup: {
        title: 'Add Inpatient/Outpatient Treatment',
        registrationPin: 'Registration PIN (provided by your facility)',
        cancel: 'Cancel',
        submit: 'Submit',
      },
    },
  },
  errors: {
    invalidPhoneNumber: 'Invalid Phone Number',
    registrationPinNoMatch: 'The registration PIN does not match our records for the current patient.',
    linkingStay: 'Error linking stay.  Please try again.',
    pinInvalid: 'Invalid',
  },
  deletePopup: {
    title: 'Delete Account',
    description: 'If you wish to delete your account, click Continue below and then check your email for further instructions.',
    cancel: 'Cancel',
    continue: 'Continue',
    error: 'An unexpected error occurred. Please try again.',
  },
};

export const patientAccountTranslationsES: PatientAccountTranslations = {
  loadingTitle: 'Información y configuración de la cuenta',
  loadingText: 'Cargando configuración de la cuenta...',
  accountInfo: {
    title: 'Información de la cuenta',
    accountId: {
      title: 'Correo electrónico/ID de cuenta',
      changePassword: 'Cambiar contraseña',
    },
    accountHolder: {
      title: 'Información del titular de la cuenta',
      firstName: 'Nombre',
      lastName: 'Apellido',
      relationshipToPatient: 'Relación con el paciente',
      preferredLanguage: 'Idioma Preferido',
      address: 'Dirección',
      city: 'Ciudad',
      state: 'Estado',
      zipCode: 'Código postal',
      phone: 'Teléfono',
      emailForNotifications: 'Correo electrónico para notificaciones',
      notifications: 'Notificaciones',
      notificationsEmail: 'Correo electrónico',
      loading: 'Cargando...',
      selectAState: 'Seleccione un estado',
      selectARelationship: 'Seleccione una relación',
      selectALanguage: 'Seleccione un Idioma',
      deleteAccount: 'Eliminar cuenta',
      cancel: 'Cancelar',
      saveChanges: 'Guardar cambios',
    },
  },
  patientInfo: {
    title: 'Información del paciente',
    erContact: {
      title: 'Contacto de emergencia',
      firstName: 'Nombre',
      lastName: 'Apellido',
      relationshipToPatient: 'Relación con el paciente',
      phoneNumber: 'Número de teléfono',
      emailAddress: 'Correo electrónico',
      selectARelationship: 'Seleccione una relación',
    },
    preferredFacility: {
      title: 'Centro preferido',
      facility: 'Centro',
      phoneNumber: 'Número de teléfono',
      websiteAddress: 'Dirección del sitio web',
      cancel: 'Cancelar',
      saveChanges: 'Guardar cambios',
      selectAFacility: 'Seleccione un centro',
    },
    previousTreatments: {
      title: 'Tratamientos previos hospitalarios/ambulatorios',
      addTreatment: 'Agregar un tratamiento hospitalario/ambulatorio',
      popup: {
        title: 'Agregar tratamiento hospitalario/ambulatorio',
        registrationPin: 'PIN de registro (proporcionado por su centro)',
        cancel: 'Cancelar',
        submit: 'Enviar',
      },
    },
  },
  errors: {
    invalidPhoneNumber: 'Número de teléfono no válido',
    registrationPinNoMatch: 'El PIN de registro no coincide con nuestros registros para el paciente actual.',
    linkingStay: 'Error al vincular la estancia. Por favor, inténtelo de nuevo.',
    pinInvalid: 'No válido',
  },
  deletePopup: {
    title: 'Eliminar cuenta',
    description: 'Si desea eliminar su cuenta, haga clic en Continuar a continuación y luego revise su correo electrónico para obtener más instrucciones.',
    cancel: 'Cancelar',
    continue: 'Continuar',
    error: 'Ocurrió un error inesperado. Por favor, inténtelo de nuevo.',
  },
};
